function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "devices",
  transform: "translate(-2.25 -4.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11542",
  "data-name": "Path 11542",
  d: "M9.512,30.274H4.066A1.816,1.816,0,0,1,2.25,28.459V17.566A1.816,1.816,0,0,1,4.066,15.75H9.512a1.816,1.816,0,0,1,1.816,1.816V28.459A1.816,1.816,0,0,1,9.512,30.274ZM4.066,17.566V28.459H9.512V17.566Z",
  transform: "translate(0 -2.172)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11543",
  "data-name": "Path 11543",
  d: "M26.286,4.5H6.316A1.816,1.816,0,0,0,4.5,6.316v5.447H6.316V6.316H26.286V19.024H13.578V20.84h1.816v3.631H13.578v1.816h8.17V24.471H17.209V20.84h9.078A1.816,1.816,0,0,0,28.1,19.024V6.316A1.816,1.816,0,0,0,26.286,4.5Z",
  transform: "translate(-0.434)",
  fill: "#ac1ede"
}));

var SvgDevices = function SvgDevices(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25.417,
    height: 23.602,
    viewBox: "0 0 25.417 23.602",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDevices, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/devices.c3146cc2.svg";
export { ForwardRef as ReactComponent };